import cx from 'classnames';
import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import 'swiper/css';

import { useLocation } from 'react-router-dom';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import 'yet-another-react-lightbox/styles.css';
import { ReactComponent as QuotesSVG } from '../../../../assets/images/home/quotes.svg';
import Footer from '../../components/Footer';
import Header from '../../components/Header/Header';
import PreFooterBlock from '../../components/PreFooterBlock';
import './styles.scss';

const HowItWorksPage = () => {
  const [isOpenScheduleDemoModal, setIsOpenScheduleDemoModal] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <main className={cx('home-page how-it-works-page', { isMobile })}>
      <Header setIsOpenScheduleDemoModal={setIsOpenScheduleDemoModal} isOpenScheduleDemoModal={isOpenScheduleDemoModal} />
      <div className="home-page-content">
        <div className="how-it-works-page-hero">
          <div className="top-block">
            {isMobile ? (
              <>
                <p className="how-it-works-how-title">How</p>
                <img src="/images/light-logo.svg" alt="AllCareForms" />
                <p className="how-it-works-works-title">Works</p>
              </>
            ) : (
              <>
                <span className="how-it-works-title">How</span>
                <img src="/images/light-logo.svg" alt="AllCareForms" />
                <span className="how-it-works-title">Works</span>
              </>
            )}
          </div>
          <div className="bottom-block">
            <p className="how-it-works-subtitle">A complete overview of our process, from first meeting to paper-free.</p>
            <button className="request-demo-btn" onClick={() => setIsOpenScheduleDemoModal(true)}>
              Request a Demo{' '}
              <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.75 9.89771H14.25" stroke="#448AFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path
                  d="M9 4.64771L14.25 9.89771L9 15.1477"
                  stroke="#448AFF"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="our-process-block">
          <h3 className="our-process-title">Our Process</h3>
          <div className="our-process-list">
            <div className="our-process-item">
              <div className="left-block">
                <div className="icon-wrapper">
                  <img src="/images/home/our-process-1.svg" />
                </div>
              </div>
              <div className="right-block">
                <div className="right-block-content">
                  <p className="right-block-title">Step 1</p>
                  <p className="right-block-text">Schedule presentation</p>
                </div>
              </div>
            </div>

            <div className="our-process-item">
              <div className="left-block">
                <div className="icon-wrapper">
                  <img src="/images/home/our-process-2.svg" />
                </div>
              </div>
              <div className="right-block">
                <div className="right-block-content">
                  <p className="right-block-title">Step 2</p>
                  <p className="right-block-text">We collect samples of your current forms and related documentation processes</p>
                </div>
              </div>
            </div>

            <div className="our-process-item">
              <div className="left-block">
                <div className="icon-wrapper">
                  <img src="/images/home/our-process-3.svg" />
                </div>
              </div>
              <div className="right-block">
                <div className="right-block-content">
                  <p className="right-block-title">Step 3</p>
                  <p className="right-block-text">
                    We convert your forms in to digital editions and make them follow your documentation process.
                  </p>
                </div>
              </div>
            </div>

            <div className="our-process-item">
              <div className="left-block">
                <div className="icon-wrapper">
                  <img src="/images/home/our-process-4.svg" />
                </div>
              </div>
              <div className="right-block">
                <div className="right-block-content">
                  <p className="right-block-title">Step 4</p>
                  <p className="right-block-text">
                    We help you to enroll employees into the platform — takes about 5 minutes to enroll 5 employees.
                  </p>
                </div>
              </div>
            </div>

            <div className="our-process-item">
              <div className="left-block">
                <div className="icon-wrapper">
                  <img src="/images/home/our-process-5.svg" />
                </div>
              </div>
              <div className="right-block">
                <div className="right-block-content">
                  <p className="right-block-title">Step 5</p>
                  <p className="right-block-text">
                    The transition from paper overload to digital efficiencies begins and progresses one form/process at a time
                  </p>
                </div>
              </div>
            </div>

            <div className="our-process-item">
              <div className="left-block">
                <div className="icon-wrapper">
                  <img src="/images/home/our-process-6.svg" />
                </div>
              </div>
              <div className="right-block">
                <div className="right-block-content">
                  <p className="right-block-title">Step 6</p>
                  <p className="right-block-text">After about 4 months, your organization is a paper-free operation. </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="core-capabilities">
          <h3 className="core-capabilities-title">Designed for the Way You Work</h3>
          <div className="core-capabilities-grid-container">
            <div className="core-capabilities-item">
              <div className="corner-image-wrapper">
                <img className="corner-image" src="/images/home/way-you-work-1.svg" />
              </div>
              <div className="core-capabilities-item-content">
                <h4 className="core-capabilities-item-title">Real-time infection control records</h4>
                <p className="core-capabilities-item-subtitle">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
              </div>
            </div>
            <div className="core-capabilities-item core-capabilities-easy-audit">
              <div className="corner-image-wrapper">
                <img className="corner-image" src="/images/home/way-you-work-2.svg" />
              </div>
              <div className="core-capabilities-item-content">
                <h4 className="core-capabilities-item-title">Fire drill tracking with digital signatures</h4>
                <p className="core-capabilities-item-subtitle">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
              </div>
            </div>
            <div className="core-capabilities-item core-capabilities-item-tall">
              <div>
                <img className="core-capabilities-item-screenshot-img" src="/images/home/way-you-work-missed-log-screenshot.png" />
              </div>
              <div className="corner-image-wrapper">
                <img className="corner-image" src="/images/home/way-you-work-3.svg" />
              </div>
              <div className="core-capabilities-item-content">
                <h4 className="core-capabilities-item-title">HR evaluations & missed punch forms</h4>
                <p className="core-capabilities-item-subtitle">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
              </div>
            </div>
            <div className="core-capabilities-item core-capabilities-item-wide">
              <div className="core-capabilities-item-screenshot-wrapper">
                <img className="core-capabilities-item-screenshot-img" src="/images/home/way-you-work-woman.jpg" />
              </div>
              <div className="core-capabilities-item-right-block">
                <div className="corner-image-wrapper">
                  <img className="corner-image" src="/images/home/way-you-work-4.svg" />
                </div>
                <div className="core-capabilities-item-content">
                  <h4 className="core-capabilities-item-title">CNA Assignments on tablets</h4>
                  <p className="core-capabilities-item-subtitle">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className="reviews-block">
          <div className="review-block-item">
            <div className="quotes-wrapper">
              <QuotesSVG />
            </div>
            <div className="review-text-wrapper">
              Implementation of <span className="blue-part">AllCareForms</span> at our facility was well organized and well received by
              employees. We were able to start using the program within a week.
            </div>
            <div className="reviewer-wrapper">
              <div className="reviewer-name-wrapper">
                <p className="reviewer-name">Shonte Allen</p>
                <p className="reviewer-position">Administrator, The Residence At Arrowood, Pittsburgh PA</p>
              </div>
            </div>
          </div>
          <div className="review-block-item">
            <div className="quotes-wrapper">
              <QuotesSVG />
            </div>
            <div className="review-text-wrapper">
              Our transition from another educational platform was seamless and well guided. AllCareForms staff{' '}
              <span className="blue-part">helped us to onboard 130 employees</span> within a few days.
            </div>
            <div className="reviewer-wrapper">
              <div className="reviewer-name-wrapper">
                <p className="reviewer-name">Kevin Kolarosky</p>
                <p className="reviewer-position">Administrator, Townview Health and Rehab Center, Canonsburg PA</p>
              </div>
            </div>
          </div>
        </div>

        <PreFooterBlock
          title="Ready to eliminate paper and optimize compliance?"
          subtitle="Customized solutions for every operational challenge — from education to audits."
          setIsOpenScheduleDemoModal={setIsOpenScheduleDemoModal}
        />
      </div>

      <Footer />
    </main>
  );
};

export default HowItWorksPage;
